import {ImportOption} from './importOptionEnum';
import {FileToDownload} from './file-to-download';
import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('ImportRequirement')
export class ImportRequirement {
  // TODO: try to have homogeneous type for all ids.
  @JsonProperty('pId',Number,true)
  pId = 0 ;

  @JsonProperty('qId',Number,true)
  qId = 0;

  @JsonProperty('tId',Number,true)
  tId = 0;

  @JsonProperty('terminalType',String,true)
  terminalType = '0';

  @JsonProperty('importMode',String,true)
  importMode = ImportOption.Only;

  @JsonProperty('fileToDownload',FileToDownload)
  fileToDownload = new FileToDownload();

  constructor() {

  }

}
